import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModelSelectionUndoState } from '../ModelSelectionPage';
import { StoreState } from '../../../store/store';
import { ModelType } from '../../../store/global-types/customization-types';
import AeTitleRuleForm from '../AeTitleRuleForm';
import { aeTitleRuleActionUpdated, aeTitleRuleRemoved, doseSelectors } from '../../../store/dose/doseSlice';
import { makeSelectFormValidationErrorsForAeTitleRule } from '../../../store/dose/doseSelectors';
import { AETITLE_PREFIX_DOSE } from '../../../store/dose/dose-types';



interface DoseAeTitleRuleProps {
    aeTitleRuleId: string,
    runningNumber: number,
    isLastRule: boolean,
    setUndoState: (undoState: ModelSelectionUndoState) => void,
    isUndoDisabled?: boolean,
}

const DoseAeTitleRule = (props: DoseAeTitleRuleProps) => {
    const { aeTitleRuleId, runningNumber, isLastRule, setUndoState, isUndoDisabled } = props;

    const dispatch = useDispatch();

    const aeTitleRule = useSelector((state: StoreState) => doseSelectors.selectAeTitleRuleById(state, aeTitleRuleId));
    const validationError = useSelector((state: StoreState) => doseSelectors.selectCustomizationValidationError(state, aeTitleRuleId));
    const selectFormValidationErrorsForRule = makeSelectFormValidationErrorsForAeTitleRule();
    const formValidationErrors = useSelector((state: StoreState) => selectFormValidationErrorsForRule(state, aeTitleRuleId));

    const handleAeTitleActionChanged = useCallback((action: string) => {
        dispatch(aeTitleRuleActionUpdated({ id: aeTitleRuleId, action }));
    }, [dispatch, aeTitleRuleId]);


    const handleAeTitleRemoved = useCallback(() => {
        dispatch(aeTitleRuleRemoved(aeTitleRuleId));
    }, [dispatch, aeTitleRuleId]);


    // don't render anything if we don't have a valid object
    if (aeTitleRule === undefined) {
        return null;
    }

    return (
        <AeTitleRuleForm
            aeTitleRule={aeTitleRule}
            prefix={AETITLE_PREFIX_DOSE}
            modelType={ModelType.Dose}
            onAeTitleRuleActionUpdated={handleAeTitleActionChanged}
            onAeTitleRuleRemoved={handleAeTitleRemoved}
            runningNumber={runningNumber}
            isLastRule={isLastRule}
            setUndoState={setUndoState}
            validationError={validationError}
            formValidationErrors={formValidationErrors}
            isUndoDisabled={isUndoDisabled}
         />
    );
}

export default DoseAeTitleRule;
